import React, { useState, useRef } from "react";
import * as equipmentsAction from "../../../redux/actions/equipmentsAction";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GRID_DEFAULT_PAGE_SIZE, ORG_ID, LOGIN_ORG_ID, HBNEXT_ORG_ID } from "../../../constant/constant";
import {
  ACCESS_DENIED,
  ADMIN_ADD_EQUIPMENTS,
  ADMIN_EDIT_EQUIPMENT,
  ADMIN_EQUIPMENTS,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import EquipmentList from "../component/equipments/equipmentList";
import { API_STATUS } from "../../../constant/constant";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient, roleAccess } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";
export default function EquipmentsContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const equipmentList = useSelector((state) => state.equipmentList);
  const isLoading = useSelector(
    (state) =>
      state.equipmentList?.isLoading || state.deleteEquipment?.isLoading,
  );

  const clientDivision = useSelector((state) => state.getDropdownDataKeyValue);

  const equipmentCategoryData = useSelector(
    (state) => state?.getDropdownDataKeyValue?.data?.equipmentCategories,
  );
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const divisions = userInfo?.divisions?.filter(
    (i) => i?.serviceType == PRODUCT_ID(),
  );
  const isClient = userInfo?.isClient;
  const { HbnClientSystemRole } = roleAccess();
  const hbnextRole = parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);

  const showAllDivisions = HbnClientSystemRole || hbnextRole;

  const divisionsWithAll = showAllDivisions
    ? [{ key: "AllDivision", value: "All Divisions" }, ...(divisions ?? [])]
    : divisions;

  const [clientDivisions, setClientDivisions] = useState();
  const valueCheck = clientDivisions || divisions;
  const clientSwitch = isClient || ORG_ID() !== LOGIN_ORG_ID();

  useEffect(() => {
    if (clientSwitch || showAllDivisions) {
      if (clientDivision?.status === API_STATUS.SUCCESS) {
        const divisions = clientDivision?.data?.divisons && [
          ...clientDivision?.data?.divisons,
        ];
        divisions?.unshift({ key: "AllDivision", value: "All Divisions" });
        setClientDivisions(divisions);
      }
    }
  }, [clientDivision, clientSwitch, showAllDivisions]);

  const defaultData = {
    organisationId: ORG_ID(),
    divisionId:
      (clientSwitch && valueCheck) || showAllDivisions
        ? 0
        : divisions[0]?.key,
    search: "",
    page: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    userId: 0,
    statusIds: "",
    isSendMail: false,
  };

  const deleteEquipment = useSelector((state) => state.deleteEquipment);
  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_EDIT_EQUIPMENT];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("equipmentListPreserveState") === "true";
    sessionStorage.removeItem("equipmentListPreserveState");

    if (isFromPreserveRoute && equipmentList?.filterObjs) {
      setShouldRestoreState(true);
      getEquipmentList(equipmentList.filterObjs);
    } else {
      setShouldRestoreState(false);
      getEquipmentList(defaultData);
    }
  }, []);
  useEffect(() => {
    if (
      deleteEquipment?.status === API_STATUS.SUCCESS &&
      deleteTriggeredRef.current
    ) {
      deleteTriggeredRef.current = false;
      const currentFilter = equipmentList?.filterObjs || defaultData;
      getEquipmentList(currentFilter);
    }
  }, [deleteEquipment]);

  const getEquipmentList = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(equipmentsAction.getEquipmentList(data));
    dispatch(equipmentsAction.getEquipmentFilterObj(data));
  };

  const handleDeleteOnClick = (EquipmentId) => {
    if (InactiveClient()) return;
    deleteTriggeredRef.current = true;
    dispatch(equipmentsAction.deleteEquipmentAction(EquipmentId));
  };

  const handleEditOnClick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("equipmentListPreserveState", "true");
    navigate(ADMIN_EDIT_EQUIPMENT, {
      state: { id: rows.equipmentId, editMode: true },
    });
  };

  const addEquipment = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_EQUIPMENTS);
  };

  useEffect(() => {
    const getDropdownDataKeyValueData = {
      orgId: ORG_ID(),
      flags: [6, 10],
      productId: PRODUCT_ID(),
    };
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  useEffect(() => {
    if (equipmentList?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Equipment has been sent to registered email ID");
    }
  }, [equipmentList]);

  return (
    <>
      {checkPrivileges([12, 52, 53, 54]) ? (
        <>
          <ToastContainer />
          <EquipmentList
            equipmentList={isLoading ? [] : equipmentList?.data}
            getEquipmentList={getEquipmentList}
            isLoading={isLoading}
            addEquipment={addEquipment}
            equipmentLists={equipmentList}
            handleDeleteOnClick={handleDeleteOnClick}
            handleEditOnClick={handleEditOnClick}
            divisionDropdown={
              (clientSwitch || (showAllDivisions && valueCheck)) ? clientDivisions : divisionsWithAll
            }
            equipmentCategoryData={equipmentCategoryData}
            isShowDowdownloadButton={true}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
